import { track } from '@mobi/account/Utils/analytics'
import type { DepositLimitFrequency } from '@mobi/api-types'
import { MedicareCardColor } from '@mobi/api-types/src/account/signup'
import { type IdentityVerificationMethod } from '../typings/types'

export type VerificationAnalyticsKeys =
  | 'verification-select-option'
  | 'verification-enter-identification'
  | 'sign-up-create-password'
  | 'sign-up-deposit-limits'
  | 'verification_contact_us'
  | 'verification_fail'
  | 'verification_success'

const VERIFICATION_SELECT_OPTION: VerificationAnalyticsKeys = 'verification-select-option'
const SIGN_UP_VERIFICATION_ENTER_IDENTIFICATION: VerificationAnalyticsKeys =
  'verification-enter-identification'
const SIGN_UP_CREATE_PASSWORD: VerificationAnalyticsKeys = 'sign-up-create-password'
const SIGN_UP_DEPOSIT_LIMITS: VerificationAnalyticsKeys = 'sign-up-deposit-limits'
const SIGN_UP_VERIFICATION_CONTACT_US: VerificationAnalyticsKeys = 'verification_contact_us'
const SIGN_UP_VERIFICATION_FAIL: VerificationAnalyticsKeys = 'verification_fail'
const SIGN_UP_VERIFICATION_SUCCESS: VerificationAnalyticsKeys = 'verification_success'

export const trackVerificationSelectOption = (
  optionSelected: IdentityVerificationMethod | undefined,
  repeatAttempt: number
) =>
  track(VERIFICATION_SELECT_OPTION, {
    optionSelected: optionSelected ?? 'None',
    repeatAttempt: repeatAttempt.toString(),
  })

export const trackVerificationEnterIdentification = (
  optionSelected: IdentityVerificationMethod,
  verifyResult: 'success' | 'fail',
  medicareColour?: MedicareCardColor | null
) => {
  track(SIGN_UP_VERIFICATION_ENTER_IDENTIFICATION, {
    optionSelected,
    verifyResult,
    medicareColour: (() => {
      switch (medicareColour) {
        case MedicareCardColor.Green:
          return 'green'
        case MedicareCardColor.Yellow:
          return 'yellow'
        case MedicareCardColor.Blue:
          return 'blue'
        default:
          return undefined
      }
    })(),
  })
}

export const trackSignUpCreatePassword = (
  previousStep: 'verified-address' | 'verified-identification'
) =>
  track(SIGN_UP_CREATE_PASSWORD, {
    previousStep,
    BiometricStatus: undefined,
  })

export const trackSignUpDepositLimits = (
  depositFrequency: DepositLimitFrequency,
  limitAmount: string,
  skipped: boolean
) =>
  track(SIGN_UP_DEPOSIT_LIMITS, {
    depositFrequency: depositFrequency ?? 'None',
    limitAmount,
    skipped,
  })

export const trackSignUpVerificationContactUs = () => track(SIGN_UP_VERIFICATION_CONTACT_US)

export const trackSignUpVerificationFail = (message: string) =>
  track(SIGN_UP_VERIFICATION_FAIL, {
    message,
  })

export const trackSignUpVerificationSuccess = (attempt: number) =>
  track(SIGN_UP_VERIFICATION_SUCCESS, {
    previousStep: attempt > 0 ? 'verified-identification' : 'verified-address',
  })
